import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';

const pageData = {
  seo: {
    title: 'Custom Real Estate Portals & MLS Software | RojrzTech',
    description: 'Transform property management and agency listings with custom MLS integration, virtual tour support, lead routing CRMs, and agent scheduling systems.',
  },
  hero: {
    badge: 'REAL ESTATE SOLUTIONS',
    slides: [
      {
        heading: { pre: 'Premium', gold: 'Real Estate Portals', post: '& MLS Software' },
        subheading: 'We build custom property listing websites, MLS search APIs, and lead routing CRM systems that connect prospective buyers with real estate agents.',
        pills: ['MLS Listing', '3D Tour Support', 'Lead Routing CRM', 'Agent Calendar', 'Virtual Tour'],
        image: '/realstate.jpeg',
      },
      {
        heading: { pre: 'MLS Search &', gold: 'Interactive Property Maps' },
        subheading: 'Power your listing website with high-speed property search criteria, integrated Mapbox/Google Maps geographic search, and neighborhood data overlays.',
        pills: ['RET/IDX Feed', 'Mapbox Map API', 'Polygon Filter', 'Neighborhood Data', 'High-Speed API'],
        image: '/realstate1.jpeg',
      },
      {
        heading: { pre: 'Lead Capture &', gold: 'Agent Calendars' },
        subheading: 'Ensure listings capture hot leads. Our automated routing directs queries to listed agents and allows clients to schedule private home tours instantly.',
        pills: ['Auto Lead Route', 'Tour Booking', 'Agent Calendar Sync', 'SMS Lead Alerts', 'Analytics'],
        image: '/realstate.jpeg',
      },
    ],
  },
  showcase: {
    phoneTitle: 'PROPERTY PORTAL',
    phoneSubtitle: 'Search local listings and book private viewings instantly.',
    tags: [
      { title: 'RET / IDX MLS Feed Sync', desc: 'Sync local MLS database listings automatically every 15 minutes.' },
      { title: 'Local Search Lead Capture', desc: 'Rank top-3 for local property search queries like "apartments for sale".' },
      { title: 'Automated Lead Routing', desc: 'Route prospective buyer details to active listing agents instantly.' },
      { title: '3D & Virtual Tour Support', desc: 'Integrate Matterport 3D digital tours directly on listing detail pages.' },
      { title: 'Interactive Tour Booking', desc: 'Allow buyers to request private physical or virtual tour appointment slots.' },
      { title: 'Agent Management Dashboard', desc: 'Give agents tools to update descriptions, add photos, and manage leads.' },
    ],
  },
  videoSection: {
    title: 'Listing CRM Dashboard Demo',
    subtitle: 'See how our admin dashboard aggregates MLS listings and routes buyer leads to regional agents.',
    frameLabel: 'REAL ESTATE AGENT DASHBOARD',
  },
  cards: {
    title: 'Custom Engineering for Real Estate Agencies',
    subtitle: 'RojrzTech builds responsive, lead-optimized real estate systems that load instantly and integrate with local property listing databases.',
    items: [
      {
        icon: '🏠',
        title: 'IDX/MLS Portal Builder',
        description: 'Create custom property listing websites synced directly with local databases, offering modern search layouts and advanced filters.',
      },
      {
        icon: '📊',
        title: 'Lead Management CRM',
        description: 'Keep track of client inquiries, automate email follow-ups, evaluate property views, and manage agent assignment logs.',
      },
      {
        icon: '⚡',
        title: 'Matterport & 3D Tours',
        description: 'Engage remote buyers with virtual listing integrations. Embed 3D walkthroughs, video tours, and floor plans seamlessly.',
      },
    ],
  },
  features: {
    title: 'Advanced Real Estate Software Features',
    subtitle: 'Everything your brokerage needs to capture high-value buyer leads and manage listing inventories.',
    items: [
      'IDX/MLS Auto Sync',
      'Matterport 3D Tour Embed',
      'Advanced Property Search',
      'Map Search (Google/Mapbox)',
      'Agent Assignment Logic',
      'Lead Form Notifications',
      'Tour Scheduling Widgets',
      'Agent Profile Pages',
      'Virtual Showing Booking',
      'Neighborhood Stats Overlay',
      'Mortgage Estimator Widget',
      'Listing Photo Slideshows',
    ],
  },
};

const RealEstate = () => {
  return <IndustryPageTemplate pageData={pageData} />;
};

export default RealEstate;
